export interface Inbox {
    id: string;
    name: string;
    color: string;
    created_at: string;
    updated_at: string;
}

export enum InboxStatus {
    OPEN = 'open',
    CLOSED = 'closed',
}

export enum InboxOrder {
    NEWEST = 'newest',
    OLDEST = 'oldest',
}

export interface InboxFilter {
    status?: InboxStatus | null;
    order?: InboxOrder | null;
    user_id?: string | null;
    team_id?: string | null;
}

export interface InboxItem {
    key: string;
    name: string;
    icon: any;
    iconType: 'icon' | 'image' | 'emoji';
    current: boolean;
    total: number;
    filter?: InboxFilter;
}

export interface InboxSection {
    group: string;
    items: InboxItem[];
}

export interface ApiInboxItem {
    name: string;
    total: number;
    user?: {
        id: string;
        name: string;
        photo: string;
    }
}

export interface ApiTeamItem {
    name: string;
    total: number;
    team?: {
        id: string;
        icon: string;
    }
}

export interface ApiUserItem {
    name: string;
    total: number;
    user?: {
        id: string;
        name: string;
        photo: string;
    }
}

export interface ApiResponse {
    inbox: ApiInboxItem[];
    teams: ApiTeamItem[];
    users: ApiUserItem[];
}
